<template>
    <span>
        {{ text }}
    </span>
</template>

<script>
export default {
props: {
    text: {
        type: String,
        required: true
    },
},
}
</script>

<style lang="scss" scoped>
span {
    text-align: center;
    width: 42px;
    padding: 4px 8px;
    border-radius: 26px;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: inline-block;
    background: #F0F5FA;
    color: #727D94;
    text-transform: uppercase;
}
</style>